import { FrequencyTypeMap } from "../../../../Resoures/Contents";
import * as React from "react";
import { getMoneyFormat } from "../../NewQuoteWizard/Components/Shared/Utils";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { PensionArrangementTypeArrayMap } from "../../../../../Admin/Company/CompanyWizard/Resource/Content";
import { ITypographyProps, Typography } from "../../../../../Shared/Typography/Typography";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { TransferInModelMap, WithdrawalMethodMap } from "../Resource/Contents";
import { TransferType } from "../../../../../../Wrap/Constants/Enums/Domain/TransferType";
import { PensionArrangementType } from "../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { RegularWithdrawalModel } from "../../../../../../Wrap/Models/Models/Processes/RegularWithdrawal/RegularWithdrawalModel";
import { CheckboxGroup } from "../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { InvestmentAllocation } from "../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { MoneyOrPercentage } from "../../../../../../Wrap/Models/Models/Shared/MoneyOrPercentage";
import { MoneyOrPercentageType } from "../../../../../../Wrap/Constants/Enums/MoneyOrPercentageType";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { SubAccountTypeHelper } from "../Helpers/SubAccountTypeHelper";
import { StringHelper } from "../../../../../../react-core/Helpers/StringHelper";
import { BankAccountInstruction } from "../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { ContributionBase } from "../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ContributionBase";
import { ApplyModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { IncomePaymentDestination } from "../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentDestination";
import { incomePaymentDetailsLabels } from "../SIPP/IncomePaymentDetails/Resource/Content";
import { ClientDetails } from "../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import { RegularPaymentAdviceCharge } from "../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/RegularPaymentAdviceCharge";
import { Gender } from "../../../../../../Wrap/Constants/Enums/Domain/Gender";
import { TitleMap } from "../../../../../Shared/Entities/Maps/TitleMap";
import { ContinueUntil } from "../../NewBusinessWizard/Resource/Contents";

//PaymentsIn
export const singlePaymentParse = (model: any, subAccountType: SubAccountType) => {
    if (!model) {return handleNull();}
    return (
        <>
            <span>{getMoneyFormat(model.Money.Amount)}</span>
            <br />
            {model.TaxRelief && SubAccountTypeHelper.isOnPlatformPension(subAccountType) && (
                <span>
                    {MoneyDisplayHelper.FromatMoneyDisplay(
                        (model?.Money?.Amount || 0) * 1.25,
                        model?.Money?.CurrencyCode || CurrencyCode.GBP
                    ) + " including tax relief(gross)"}
                </span>
            )}
        </>
    );
};

export const regularPaymentParse = (model: any, subAccountType: SubAccountType) => {
    if (!model) {return handleNull();}
    const moneyAndFrnquency = moneyOrfrenquencyParse(model);
    const firstCollectionDate = dateParser(model.FirstCollectionDate);
    return (
        <>
            <span>
                {firstCollectionDate}
                {moneyAndFrnquency}
                {model.ContinueUntil != null ? `Until date ${dateParser(model.ContinueUntil)}` : `Until notified`}
                <br />
            </span>
            <br />
            {model.TaxRelief && SubAccountTypeHelper.isOnPlatformPension(subAccountType) && (
                <span>
                    {MoneyDisplayHelper.FromatMoneyDisplay(
                        (model?.Money?.Amount || 0) * 1.25,
                        model?.Money?.CurrencyCode || CurrencyCode.GBP
                    ) + " including tax relief(gross)"}
                </span>
            )}
        </>
    );
};

export const transferInParse = (model: any, subAccountType: SubAccountType): Array<any> => {
    const transferModel = model[TransferInModelMap[subAccountType]];
    switch (subAccountType) {
        case SubAccountType.Sipp:
        case SubAccountType.Npr:
            return sippTransferInParse(transferModel);
        case SubAccountType.StocksIsa:
            return isaTransferInParse(transferModel);
        case SubAccountType.InvestmentAccount:
            return ppTransferInParse(transferModel);
        default:
            return [];
    }
};

const sippTransferInParse = (transferModel: any) => {
    if (!transferModel) {return [];}
    const result = [];
    transferModel.map((ele) => {
        result.push(
            <>
                <span>{PensionArrangementTypeArrayMap.optionsmap[ele.PensionSource]}</span>
                <br />
                {!ele.CurrentValue.Amount ? (
                    <span>Re-register assets</span>
                ) : (
                    <span>{getMoneyFormat(ele.CurrentValue.Amount)}</span>
                )}
                <br />
                <span>{ele.ProviderDetails?.Name}</span>
            </>
        );
    });
    return result;
};

const isaTransferInParse = (transferModel: any) => {
    if (!transferModel) {return [];}
    const result = [];
    transferModel.map((ele) => {
        result.push(
            <>
                {ele.TransferType == TransferType.Cash ? (
                    <>
                        <span>Cash</span>
                        <br />
                        <span>{getMoneyFormat(ele.CurrentValue.Amount)}</span>
                    </>
                ) : (
                    <span>{"S&S ISA"}</span>
                )}
                <br />
                <span>{ele.ProviderDetails?.Name}</span>
            </>
        );
    });
    return result;
};

const ppTransferInParse = (transferModel: any) => {
    if (!transferModel) {return [];}
    const result = [];
    transferModel.map((ele) => {
        result.push(
            <>
                {ele.CurrentValue.Amount ? (
                    <span>{getMoneyFormat(ele.CurrentValue.Amount)}</span>
                ) : (
                    <span>Re-register assets</span>
                )}
                <br />
                <span>{ele.ProviderDetails?.Name}</span>
            </>
        );
    });
    return result;
};

//Advice Charge
export const adviserParse = (model: MoneyOrPercentage) => {
    const money = model?.Money.Amount ? getMoneyFormat(model.Money.Amount) : null;
    const percentage = model?.Percentage ? model.Percentage + "%" : null;
    if (!money && !percentage) {return false;}
    return (
        <span>
            {model?.Type == MoneyOrPercentageType.Money ? money : percentage}
            <br />
            {model?.Frequency ? FrequencyTypeMap[model.Frequency] : ""}
        </span>
    );
};

export const regularAdviceParse = (model: RegularPaymentAdviceCharge) => {
    const money = model?.AdviceCharge?.Money?.Amount ? getMoneyFormat(model.AdviceCharge.Money.Amount) : null;
    const percentage = model?.AdviceCharge?.Percentage ? model.AdviceCharge.Percentage + "%" : null;
    if (!money && !percentage) {return false;}
    return (
        <span>
            {model.AdviceCharge.Type == MoneyOrPercentageType.Money ? money : percentage}
            <br />
            {model.Frequency ? FrequencyTypeMap[model.Frequency] : ""}
        </span>
    );
};

export const ongoingAdviceParse = (model: MoneyOrPercentage) => {
    const money = model?.Money?.Amount ? getMoneyFormat(model.Money.Amount) : null;
    const percentage = model?.Percentage ? model.Percentage + "%" : null;
    if (!money && !percentage) {return false;}
    return (
        <span>
            {model?.Type == MoneyOrPercentageType.Money ? money : percentage}
            <br />
            {model?.Frequency ? FrequencyTypeMap[model.Frequency] : ""}
        </span>
    );
};

//Withdrawals
export const withdralalParse = (model: RegularWithdrawalModel[], process: ProcessType): Array<any> => {
    if (!model || model.length == 0) {
        return [];
    }
    return model.map((ele) => {
        return (
            <>
                <span>Amount: {moneyOrPercentage(ele.ClientRegularPayment.Withdrawal)}</span>
                <br />
                <span>Frequency: {FrequencyTypeMap[ele.ClientRegularPayment.Withdrawal.Frequency]}</span>
                <br />
                <span>First withdrawal date: {dateParser(ele.ClientRegularPayment.FirstCollectionDate)}</span>
                <br />
                <span>Continue until: {ele.ClientRegularPayment.IsContinue ? ContinueUntil[0] : ContinueUntil[1]}</span>
                <br />
                {!ele.ClientRegularPayment.IsContinue && (
                    <>
                        <span>Continue - until date: {dateParser(ele.ClientRegularPayment.DeferredFromDate)}</span>
                        <br />
                    </>
                )}
                {process == ProcessType.NB && (
                    <>
                        <span>Withdrawal method: {WithdrawalMethodMap[ele.ClientRegularPayment.WithdrawalMethod]}</span>
                        <br />
                    </>
                )}
                <span>{ele.ProportionallyAllocated ? "Proportionally across all assets" : "From specified"}</span>
                <br />
                {ele.ProportionallyAllocated === false && renderCheckboxGroup(ele.Allocations)}
            </>
        );
    });
};

export const prepareTypography = (
    config,
    colNum,
    type: "vertical" | "narrow" | "common" | "auto-width" | "wider" = "vertical"
): ITypographyProps => {
    return { type: type, config: config, colNum: colNum };
};

export const pensionArrangementTypeParse = (pensionSource: any) => {
    return pensionSource === PensionArrangementType.Accumulation ? "Pre-retirement" : "Post-retirement";
};

export const renderCheckboxGroup = (instruments: InvestmentAllocation[]) => {
    let dataArr = [];
    if (instruments && instruments.length > 0) {
        dataArr = instruments.map((ele) => {
            return {
                label: ele.Name,
                value: true,
                disabled: true,
            };
        });
    }
    return <CheckboxGroup type="block" options={dataArr} />;
};

export const boolParse = (data: boolean) => {
    return StringHelper.ConvertBooleanToString(data);
};

export const moneyParse = (data: number) => {
    return data ? getMoneyFormat(data) : "None";
};

export const bankAccountParseWithHolderName = (
    bankAccountId: number,
    model: any[],
    destination: IncomePaymentDestination
) => {
    const bankAccountDetail = model.find((x) => x.BankAccountId == bankAccountId || x.Id == bankAccountId);
    if (destination && destination == IncomePaymentDestination.WrapCash)
        {return <span>{incomePaymentDetailsLabels.wrapCash}</span>;}
    return (
        <div>
            <span>
                {bankAccountDetail.AccountNumber +
                    " " +
                    bankAccountDetail.BankCodes.BankCode +
                    "-" +
                    bankAccountDetail.BankCodes.BranchCode +
                    "-" +
                    bankAccountDetail.BankCodes.ExtraCode}
            </span>
            <br />
            <span>{bankAccountDetail.HolderName}</span>
        </div>
    );
};

export const bankAccountParseById = (bankAccountId: number, model: BankAccountInstruction[]) => {
    const bankAccountDetail = model.find((x) => x.Id == bankAccountId);

    return (
        <div>
            <span>
                {bankAccountDetail.AccountNumber +
                    " " +
                    bankAccountDetail.BankCodes.BankCode +
                    "-" +
                    bankAccountDetail.BankCodes.BranchCode +
                    "-" +
                    bankAccountDetail.BankCodes.ExtraCode}
            </span>
        </div>
    );
};

export const bankAccountParse = (bankAccountNumber: string, model: ContributionBase | ApplyModel) => {
    if (bankAccountNumber == null) {
        return;
    }
    const bankAccountDetail =
        (model?.BankAccountInstructions || []).find((x) => x.AccountNumber == bankAccountNumber)?.BankCodes ||
        (model?.AllBankAccounts || []).find((x) => x.AccountNumber == bankAccountNumber)?.BankCodes;

    if (bankAccountDetail == null) {
        return;
    }

    return (
        <div>
            <span>
                {`${bankAccountNumber}​ ${bankAccountDetail.BankCode}​-${bankAccountDetail.BranchCode}​-${bankAccountDetail.ExtraCode}​`}
            </span>
        </div>
    );
};

export const dateParser = (model) => {
    return JsonDateParser.getFormatDateString(new Date(model), "dd MM yyyy", true);
};

export const jointAccountParser = (first: ClientDetails, second: ClientDetails) => {
    const birthDate1 = dateParser(first.DateOfBirth);
    const birthDate2 = dateParser(second.DateOfBirth);
    const config1 = [
        {
            title: "Title",
            data: TitleMap.getString(first.Title),
        },
        {
            title: "Name",
            data: first.FirstName + " " + first.LastName,
        },
        {
            title: "Gender",
            data: first.Gender == Gender.Female ? "Female" : "Male",
        },
        {
            title: "Date of birth",
            data: birthDate1,
        },
    ];
    const config2 = [
        {
            title: "Title",
            data: TitleMap.getString(second.Title),
        },
        {
            title: "Name",
            data: second.FirstName + " " + second.LastName,
        },
        {
            title: "Gender",
            data: second.Gender == Gender.Female ? "Female" : "Male",
        },
        {
            title: "Date of birth",
            data: birthDate2,
        },
    ];
    return (
        <>
            <h3>Joint account holder</h3>
            <div className="row">
                <div className="col-6">
                    <h3>Client 1</h3>
                    <Typography type="common" config={config1}></Typography>
                </div>

                <div className="col-6">
                    <h3>Client 2</h3>
                    <Typography type="common" config={config2}></Typography>
                </div>
            </div>
        </>
    );
};

const moneyOrfrenquencyParse = (model): JSX.Element => {
    return (
        <div>
            {getMoneyFormat(model.Money.Amount)} <br /> {FrequencyTypeMap[model.Frequency]}
        </div>
    );
};

const moneyOrPercentage = (data: MoneyOrPercentage) => {
    if (!data) {
        return MoneyDisplayHelper.FromatMoneyDisplay(0, CurrencyCode.GBP);
    }

    if (data.Type == MoneyOrPercentageType.Money) {
        return MoneyDisplayHelper.FromatMoneyDisplay(data.Money?.Amount ? data.Money.Amount : 0, CurrencyCode.GBP);
    } else {
        return `${data.Percentage || 0}%`;
    }
};

const handleNull = (): JSX.Element => {
    return <span>None</span>;
};

export interface IReviewProps {
    data: any;
    subAccountType: SubAccountType;
    process: ProcessType;
    colNum: number;
    isOpen?: boolean;
    extraInfo?: ContributionBase | ApplyModel;
    onEditAction?: () => void;
}
